import {Pipe, PipeTransform} from '@angular/core';
import {SupportedLanguagesEnum, VoiceBotLanguage, voiceBotLanguages} from '../models/voice-bot.model';
import {Observable, of} from 'rxjs';
import {LocalizationService} from '../services/localization.service';

@Pipe({
    name: 'i18nVoiceBotLanguage',
    standalone: false
})

export class I18nVoiceBotLanguagePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) {
    }

    transform(language: string): Observable<string> {
        const voiceBotLanguage = voiceBotLanguages?.find((voiceBotLanguage: VoiceBotLanguage) => {
            return voiceBotLanguage.shortName === language as SupportedLanguagesEnum;
        });

        if (!!voiceBotLanguage?.i18nKey) {
            return this.localizationService.getTranslationByKeyAsync(voiceBotLanguage.i18nKey);
        } else {
            return of(language);
        }
    }
}
